export default {"src":"/_next/static/media/first.0d16180f.svg","height":287,"width":350,"blurWidth":0,"blurHeight":0};